import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import SelectFieldComponent from '../../Common/FormField/SelectFieldComponent';

import validate from './validate';
import submit from './submit';
import messages from '../../../locale/messages';
import Loader from '../../Loader/Loader';

import logoUrl from '/public/PaymentGateway/paypal.svg';

import bt from '../../../components/commonStyle.css';
import s from '../Payout.css';

const Paypal = ({ handleSubmit, pristine, previousPage, submitting }) => {

    const { formatMessage } = useIntl();

    const siteName = useSelector(state => state.siteSettings.data.siteName);
    const availableCurrencies = useSelector(state => state?.currency?.availableCurrencies?.results);
    const payoutLoading = useSelector(state => state.reservation.payoutLoading);

    let currenciesValue = [
        { value: '', label: formatMessage(messages.chooseCurrency) }
    ]

    availableCurrencies.length > 0 && availableCurrencies.map((currency, key) => {
        if (currency.isEnable === true) {
            currenciesValue.push({
                value: currency.symbol,
                label: currency.symbol
            })
        }
    })

    return (
        <div className={cx('inputFocusColor', 'commonListingBg', 'noMarginBottom')}>
            <form onSubmit={handleSubmit(submit)}>
                <h3 className={bt.listingTitleText}>{formatMessage(messages.addPayout)}</h3>
                <img src={logoUrl} />
                <p className={cx(s.infoBox, bt.spaceTop2, bt.space2)}>
                    <FormattedMessage {...messages.paypalIntro1} /> {siteName}.
                    <FormattedMessage {...messages.paypalIntro2} /> {siteName}, <FormattedMessage {...messages.paypalIntro3} />
                    {' '}<a href={"https://www.paypal.com/"} target="_blank" className={s.stripeLink}><FormattedMessage {...messages.paypalIntro4} /></a>
                </p>
                <Field name="payEmail"
                    component={InputFieldComponent}
                    inputClass={cx(bt.commonControlInput)}
                    formGroupClass={bt.space4}
                    label={formatMessage(messages.paypalEmail)}
                    placeholder={formatMessage(messages.emailIdLabel)}
                />
                <Field name="currency"
                    label={formatMessage(messages.paypalCurrency)}
                    component={SelectFieldComponent}
                    inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                    formGroupClass={bt.space4}
                    options={currenciesValue}
                />
                <div className='doubleBtnFlexEnd'>
                    <Button className={cx(bt.btnLarge, bt.btnPrimaryBorder)} onClick={previousPage}>
                        <FormattedMessage {...messages.back} />
                    </Button>
                    <Loader
                        type={"button"}
                        buttonType={"submit"}
                        className={cx(bt.btnPrimary, bt.btnLarge, bt.loaderFlex)}
                        disabled={pristine || submitting || payoutLoading}
                        show={pristine || submitting || payoutLoading}
                        label={formatMessage(messages.finish)}
                    ></Loader>
                </div>
            </form >
        </div >
    );
}

Paypal.propTypes = {
    handleSubmit: PropTypes.any.isRequired,
    previousPage: PropTypes.any.isRequired,
    siteName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
};

export default reduxForm({
    form: 'PayoutForm', // a unique name for this form
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
})(withStyles(bt, s)(Paypal));